<template>
  <div class="container srm-list-container interface-list">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.srmListManagement.page_header')
        }}</v-toolbar-title>
      </v-col>
    </v-row>
    <!-- Condition search -->
    <v-row class="custom-form-control custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col class="pb-0 pt-0" cols="12">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1"
            cols="12"
            lg="6"
          >
            <v-row>
              <v-col cols="12" class="pb-0 pt-0" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  :label="$t('lbl.srmListManagement.findbySender')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  :label="$t('lbl.srmListManagement.findbyReceiver')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0" md="3">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  :label="$t('lbl.common.conditionSearch.findbyMessageName')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0 pr-24px" md="3">
                <v-autocomplete
                  v-model="masterSearchItems.data[0].PRCS_STS"
                  :items="srmStatusSearchArr"
                  :menu-props="{ offsetY: true }"
                  label="Status"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 text-right custom-figma-1"
            cols="12"
            lg="6"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{ offsetY: true }"
                @change="changeDtTp"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  @input="
                    fromdate_menu = false;
                    changeDate('from');
                  "
                  :max="getMaxDate"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :allowed-dates="allowedDates"
                  v-model="masterSearchItems.init.TO_DAT"
                  @input="
                    todate_menu = false;
                    changeDate('to');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">Cancel</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <!-- <v-col class="comm-header-col search-bar action-section pb-0 pt-0" cols="12" md="2"> -->
              <div class="button-group-div">
                <v-btn
                  class="search-data-analysis-button btn-height-custom btn-search primary mb-0 btn-width-1"
                  @click.native="queryList"
                >
                  <v-icon x-small class="mr-2">fa fa-search</v-icon>
                  {{ $t('btn.common.search') }}
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Button control-->
    <v-row class="btn-form-control btn-form-control-2 btn-form-control-3">
      <v-col lg="12" md="12" class="pa-0 control-button">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12" md="12">
            <div class="btn-form-control mb-0">
              <!-- //status -->
              <div class="srm-total-status-section">
                <span class="srm-total-status-text">{{ $t('btn.srmListManagement.total') }}</span>
                <span class="srm-total-status" @click="selectStatus('All')">{{ totalStt }}</span>
              </div>
              <div
                v-for="status in statusStatArr"
                @click="selectStatus(status)"
                :disabled="!$auth.manage"
                class="srm-status-stat"
                :key="status.name"
              >
                <font v-if="status.count != 0">
                  <font :class="[status.class, 'srm-status-name']"
                    >{{ status.name }} ({{ status.count }})</font
                  >
                </font>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="6" md="5">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  class="btn-top-table btn-add"
                  :disabled="!$auth.manage"
                  @click="addRowSRMList"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
                <v-btn class="btn-top-table btn-save" :disabled="!$auth.manage" @click="saveItems">
                  {{ $t('btn.common.save') }}
                </v-btn>
                <v-tooltip
                  top
                  :disabled="!isEnableDelete || !$auth.manage"
                  :max-width="tooltipWidth"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip mr-0">
                      <v-btn
                        class="btn-top-table btn-delete"
                        @click="deleteData"
                        :disabled="isEnableDelete || !$auth.manage"
                      >
                        {{ $t('btn.common.delete') }}
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ $t('msg.srmListManagement.deleteTooltipMsg') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col lg="2" md="0">
        </v-col> -->
          <v-col lg="6" md="7" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 d-flex" md="7">
                <input
                  id="btn-open-file"
                  type="file"
                  ref="upload_file_input"
                  @change="onFileChanged"
                  style="display: none"
                />
                <v-btn
                  class="btn-top-table btn-excel mt-3"
                  @click="() => $refs.upload_file_input.click()"
                  :disabled="!$auth.manage"
                >
                  Upload Excel
                </v-btn>
                <v-btn
                  class="btn-top-table btn-excel mt-3"
                  :disabled="!$auth.manage"
                  @click="generateExcelFile"
                >
                  {{ $t('btn.monitoring.excel') }}
                </v-btn>
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="30"
                  hide-details
                  dense
                  solo
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="5">
                <v-text-field
                  v-model="search"
                  heigth="30"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  @input="onFilterAnalysis"
                  @click:append="onFilterAnalysis"
                  @keyup.enter="onFilterAnalysis"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--Grid table Data-->
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <!-- Date: [2020/07/22] Apply by CLV: Appy Function DeleteData -->
        <v-table
          ref="srm_list_table"
          :height="tableHeight"
          :isMinHeight="isMinHeight"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="mainGrid"
          :row-class-name="setRowClassName"
          :select-all="selectAllChange"
          :select-change="selectItemChange"
          :row-dblclick="
            (index, item, col) => {
              item.SYSSTATUS = item.SRM_PRCS_NO ? 'U' : item.SYSSTATUS;
            }
          "
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :row-height="35"
          :class="
            $vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table custom-figma-1'
              : 'v-search-list-table-merge srm-list-table border-top'
          "
          :errorContent="'No matching records found'"
          :cell-merge="cellMerge"
          :after-update-callback="afterUpdateTable"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :paging-index="(page - 1) * itemsPerPage"
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
          @sort-change="sortChange"
        >
          <!-- 
            06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
          -->
          <template v-slot:INDEX="{ item }">
            <div class="index-col">
              {{ (page - 1) * itemsPerPage + mainGrid.indexOf(item) + 1 }}
            </div>
          </template>
          <template v-slot:custome="{ item }">
            <v-icon
              v-if="item.SYSSTATUS == 'I'"
              x-small
              color="#CD5F5F"
              @click="deleteSRMRowItem(item)"
              >fas fa-trash-alt</v-icon
            >
          </template>
          <template v-slot:SRM_SNDR="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              :disabled="!$auth.manage"
              :ref="'sndr_row_' + item.ROWID"
              v-model="item.SRM_SNDR"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              heigth="30"
              placeholder="Enter the Sender"
              outlined
              hide-details
              dense
              solo
              autofocus
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.SRM_SNDR }}</span>
          </template>
          <template v-slot:SRM_RCVR="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              :disabled="!$auth.manage"
              v-model="item.SRM_RCVR"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              heigth="30"
              placeholder="Enter the Receiver"
              outlined
              hide-details
              dense
              solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.SRM_RCVR }}</span>
          </template>
          <template v-slot:SRM_MSG_ID="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              :disabled="!$auth.manage"
              v-model="item.SRM_MSG_ID"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              heigth="30"
              placeholder="Message"
              outlined
              hide-details
              dense
              solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.SRM_MSG_ID }}</span>
          </template>
          <template v-slot:SRM_PRCS_STS="{ item }">
            <v-select
              :disabled="!$auth.manage"
              :items="srmStatusArr"
              v-model="item.SRM_PRCS_STS"
              :class="[
                srmStatusClass(item),
                'data-table-select-box',
                'srm-select-box',
                'custom-selectbox',
                'communication-select-box',
                'pt-1',
              ]"
              @change="item.SYSSTATUS = item.SRM_PRCS_NO ? 'U' : item.SYSSTATUS"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
            ></v-select>
          </template>
          <template v-slot:SRM_COMM_TP="{ item }">
            <v-select
              :disabled="!$auth.manage"
              :items="communicationArr"
              v-model="item.SRM_COMM_TP"
              class="data-table-select-box srm-select-box custom-selectbox communication-select-box pt-1"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
              @change="item.SYSSTATUS = item.SRM_PRCS_NO ? 'U' : item.SYSSTATUS"
            ></v-select>
          </template>
          <template v-slot:ATF_FILE_NAME="{ item }">
            <div class="add-refe-file-col">
              <div v-if="!$auth.manage">
                {{
                  item.ATF_FILE_CNT > 1
                    ? item.ATF_FILE_NAME +
                      `(+${item.ATF_FILE_CNT - 1} ${item.ATF_FILE_CNT - 1 > 1 ? 'Files' : 'File'})`
                    : item.ATF_FILE_NAME
                }}
              </div>

              <a
                v-else
                class="download-attach-file-text link-file-text"
                @click="downloadAttachFile(item)"
                >{{
                  item.ATF_FILE_CNT > 1
                    ? item.ATF_FILE_NAME +
                      `(+${item.ATF_FILE_CNT - 1} ${item.ATF_FILE_CNT - 1 > 1 ? 'Files' : 'File'})`
                    : item.ATF_FILE_NAME
                }}</a
              >
              <v-icon
                v-show="item.SYSSTATUS != 'I'"
                :disabled="!$auth.manage"
                x-small
                class="mr-2 ref-file-icon"
                @click="openAddReferenceFileDialog(item)"
                color="#CD5F5F"
                >far fa-arrow-alt-circle-up</v-icon
              >
            </div>
          </template>
          <template v-slot:layout="{ item }">
            <div v-if="!$auth.manage">{{ $t('btn.common.view') }}</div>
            <a
              class="link-file-text"
              v-else-if="
                item.LAY_MSG_ID != null && item.LAY_MSG_VER != null && item.LAY_PRCS_NO != null
              "
              @click="openLayoutView(item)"
              >{{ $t('btn.common.view') }}</a
            >
          </template>
          <template v-slot:merge_layout="{ item }">
            <div v-if="!$auth.manage">{{ $t('btn.common.view') }}</div>
            <a
              class="link-file-text"
              v-else-if="
                item.LAY_MSG_ID != null && item.LAY_MSG_VER != null && item.LAY_PRCS_NO != null
              "
              @click="openLayoutView(item)"
              >{{ $t('btn.common.view') }}</a
            >
          </template>
          <template v-slot:merge_FFL_FILE_NAME="{ item }">
            <span>{{ item.FFL_FILE_NAME }}</span>
          </template>
          <template v-slot:merge_MPD_FILE_NAME="{ item }">
            <span>{{ item.MPD_FILE_NAME }}</span>
          </template>
          <template class="layout-col" v-slot:merge_MAP_NAME="{ item }">
            <div v-if="!item.MAP_NAME && !$auth.manage">
              Select
            </div>
            <a
              class="link-file-text"
              v-else-if="!item.MAP_NAME && $auth.manage"
              @click="openMapListDialog(item)"
              >Select</a
            >
            <div v-else-if="item.MAP_NAME && !$auth.manage">
              {{ item.MAP_NAME }}
            </div>
            <a class="link-file-text" v-else @click="openMapListDialog(item)">{{
              item.MAP_NAME
            }}</a>
          </template>
          <template class="layout-col" v-slot:MAP_NAME="{ item }">
            <div v-if="!item.MAP_NAME && !$auth.manage">
              Select
            </div>
            <a
              class="link-file-text"
              v-else-if="!item.MAP_NAME && $auth.manage"
              @click="openMapListDialog(item)"
              >Select</a
            >
            <div v-else-if="item.MAP_NAME && !$auth.manage">
              {{ item.MAP_NAME }}
            </div>
            <a class="link-file-text" v-else @click="openMapListDialog(item)">{{
              item.MAP_NAME
            }}</a>
          </template>
        </v-table>
      </v-col>
    </v-row>

    <!-- // 2021.11.25 203728 SPKA-274 modify paging  -->
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    @change="handlePageSizeChange"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }} of
                    {{ totalCnt }}
                  </v-label>
                </div>
                <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button
                  type="button"
                  @click="changePage(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePage(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--Popup define-->
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <map-list
        v-if="dialog.type == 'mapList'"
        class="maplist-layout-dialog"
        :id="dialog.id"
        ref="mapList"
        :closeDialog="removeDialog"
        :selectFile="loadMapList"
        :fileSelected="mapFile"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :queryList="mainGrid"
        :options="dialog.options"
        @openMapperVersion="openMapperVersion($event)"
        @openScannerVersion="openScannerVersion($event)"
        @inputSelectedMap="updatedMap($event)"
      >
      </map-list>
      <mapper-version-dialog
        v-if="dialog.type == 'mapperVersion'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :dialogCheckIn="openMapperListCheckIn"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
      >
      </mapper-version-dialog>
      <mapper-check-in-dialog
        v-if="dialog.type == 'mapperCheckIn'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        ref="mapperCheckIn"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :versionList="mapperVersionHistoryItem"
        @openLoadFile="openLoadFile($event)"
        @openCodeTableDialog="openCodeTableDialog($event)"
        :options="dialog.options"
      >
      </mapper-check-in-dialog>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        class="load-file-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      >
      </load-file-dialog>
      <selectCodeList
        v-if="dialog.type == 'selectCodeList'"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        :id="dialog.id"
        ref="selectCodeList"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @selectCodeItem="selectCodeItem($event)"
      >
      </selectCodeList>
      <scanner-version-dialog
        v-if="dialog.type == 'scannerVersion'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :dialogCheckIn="openScannerListCheckIn"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
      >
      </scanner-version-dialog>
      <scanner-check-in-dialog
        v-if="dialog.type == 'scannerCheckIn'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
        @openLoadFile="openLoadFile($event)"
      >
      </scanner-check-in-dialog>
      <addReferenceFile
        v-if="dialog.type == 'addReferenceFile'"
        class="addReferenceFile-layout-dialog"
        :id="dialog.id"
        ref="addReferenceFile"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openReferenceFilesList="openReferenceList($event)"
        @inputAfterSaveReferenceFiles="updatedFile($event)"
        >>
      </addReferenceFile>
      <refenrenceFilesList
        v-if="dialog.type == 'refenrenceFilesList'"
        class="reference-files-list-layout-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @inputSelectedFile="updatedReferenceFiles($event)"
      >
      </refenrenceFilesList>
    </div>
    <dialogWindow
      ref="addNewRowEmptyDialog"
      size="max"
      title="Add New"
      detail="Sender, Receiver, Message cannot be empty"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="addNewRowDuplicateDialog"
      size="max"
      title="Add New"
      :detail="$t('msg.srmListManagement.saveBtn')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      title="Delete Data"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the selected items'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onDelete"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      size="max"
      title="Delete Success"
      color="success"
      detail="Selected item has been deleted successfully."
      @select-ok="queryAll"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validateUpload"
      size="max"
      detail="Only Excel file is allowed"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import mapList from '@/vue-dlb/views/srm/MapList.vue';
import addReferenceFile from '@/vue-dlb/views/srm/AddReferenceFile.vue';
import refenrenceFilesList from '@/vue-dlb/views/srm/ReferenceFilesList.vue';
import mapperVersionDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue';
import mapperCheckInDialog from '@/vue-dlb/views/map/MapperCheckIn.vue';
import loadFileDialog from '@/vue-dlb/views/mapbuilder/LoadFile.vue';
import selectCodeList from '@/vue-dlb/views/commons/SelectCodeTable.vue';
import scannerVersionDialog from '@/vue-dlb/views/map/ScannerVersionHistory.vue';
import scannerCheckInDialog from '@/vue-dlb/views/map/ScannerCheckIn.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import config from '@/vue-caas/config/config.js';
import { resizeTableHeight } from '@/vue-dlb/common/common';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import XLSX from 'xlsx';

export default {
  components: {
    mapList,
    addReferenceFile,
    refenrenceFilesList,
    dialogWindow,
    mapperVersionDialog,
    mapperCheckInDialog,
    loadFileDialog,
    selectCodeList,
    scannerVersionDialog,
    scannerCheckInDialog,
    SystemProgress,
  },

  computed: {
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState('common', {
      codeList: 'codeList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('srmlist', {
      mainGrid: 'mainGrid',
      statusList: 'statusList',
      mainGridSource: 'mainGridSource',
      arrFilter: 'arrFilter',
    }),
    // 203728 SPKA-49 issue 5 apply date conndition
    getMaxDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return getAppliedTimeZone();
      } else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return this.masterSearchItems.init.FR_DAT;
      } else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    isEnableDelete() {
      if (this.selectMasterRows.length > 0) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      tableHeight: 635,
      isCreated: false,
      dateTimeFormat: '',
      tooltipWidth: 300,
      fromdate_menu: false,
      maximumItem: 4,
      todate_menu: false,
      search: '',
      dialog: false,
      mapFile: '',
      mapperVersionHistoryItem: null,
      isMinHeight: true,
      // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      /**
       * 06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
       *  */

      columns: [
        {
          field: 'INDEX',
          width: 30,
          customSlot: true,
          className: 'sender-col',
          columnAlign: 'center',
          isFrozen: true,
        },
        {
          field: 'custome',
          width: 47,
          customSlot: true,
          checkShow: true,
          isShowSelect: (item) => {
            return item.SYSSTATUS != 'I';
          },
          titleAlign: 'center',
          columnAlign: 'center',
          type: 'selection',
          isFrozen: true,
        },
        {
          field: 'SRM_SNDR',
          width: 153,
          customSlot: true,
          className: 'sender-col frozen-col-bg',
          columnAlign: 'left',
          isFrozen: true,
        },
        {
          field: 'SRM_RCVR',
          width: 169,
          customSlot: true,
          className: 'receiver-col frozen-col-bg',
          columnAlign: 'left',
          isFrozen: true,
        },
        {
          field: 'SRM_MSG_ID',
          width: 118,
          customSlot: true,
          className: 'message-col frozen-col-bg',
          columnAlign: 'left',
          isFrozen: true,
        },
        {
          field: 'SRM_PRCS_STS',
          width: 145,
          columnAlign: 'center',
          className: 'status-col frozen-col-bg',
          customSlot: true,
          isFrozen: true,
        },
        {
          field: 'layout',
          width: 93,
          className: 'layout-col frozen-col-bg',
          customSlot: true,
          columnAlign: 'center',
          isResize: true,
          isFrozen: true,
        },
        {
          field: 'MAP_NAME',
          width: 170,
          className: 'map-name-col',
          customSlot: true,
          columnAlign: 'left',
          isResize: true,
        },
        {
          field: 'FFL_FILE_NAME',
          width: 157,
          columnAlign: 'left',
          className: 'font-weight-bold',
          isResize: true,
        },
        { field: 'MPD_FILE_NAME', width: 200, columnAlign: 'left', className: 'font-weight-bold' },
        { field: 'ATF_FILE_NAME', width: 252, customSlot: true, columnAlign: 'left' },
        { field: 'SRM_COMM_TP', width: 144, customSlot: true, columnAlign: 'center' },
        {
          field: 'SRM_CRE_DT',
          width: 130,
          className: 'create-date-col',
          columnAlign: 'center',
          isResize: true,
        },
        {
          field: 'SRM_UPD_DT',
          width: 130,
          className: 'update-date-col',
          columnAlign: 'center',
          isResize: true,
        },
        {
          field: 'SRM_CRE_USR',
          width: 190,
          className: 'create-user-col',
          columnAlign: 'center',
          isResize: true,
        },
        {
          field: 'SRM_UPD_USR',
          width: 190,
          className: 'update-user-col',
          columnAlign: 'center',
          isResize: true,
        },
        // {field: 'SRM_PRCS_NO', width: 190, className: "hiden-col", columnAlign: 'center'},
      ],
      /**
       * 06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
       *  */

      titleRows: [
        [
          { fields: ['INDEX'], title: this.$t('tbl.common.columnNo'), titleAlign: 'center' },
          { fields: ['custome'], title: '', titleAlign: 'center' },
          { fields: ['SRM_SNDR'], title: 'Sender', titleAlign: 'center', newprop: 'newprop' },
          { fields: ['SRM_RCVR'], title: 'Receiver', titleAlign: 'center' },
          { fields: ['SRM_MSG_ID'], title: 'Message', titleAlign: 'center' },
          { fields: ['SRM_PRCS_STS'], title: 'Status', titleAlign: 'center' },
          { fields: ['layout'], title: 'Layout', titleAlign: 'center' },
          { fields: ['MAP_NAME'], title: 'Map', titleAlign: 'center' },
          { fields: ['FFL_FILE_NAME'], title: 'FlatFile Layout', titleAlign: 'center' },
          { fields: ['MPD_FILE_NAME'], title: 'Mapping Definition', titleAlign: 'center' },
          { fields: ['ATF_FILE_NAME'], title: 'Reference Files', titleAlign: 'center' },
          { fields: ['SRM_COMM_TP'], title: 'Communication', titleAlign: 'center' },
          { fields: ['SRM_CRE_DT'], title: 'Create Date', titleAlign: 'center' },
          { fields: ['SRM_UPD_DT'], title: 'Update Date', titleAlign: 'center', orderBy: '' },
          { fields: ['SRM_CRE_USR'], title: 'Create User', titleAlign: 'center' },
          { fields: ['SRM_UPD_USR'], title: 'Update User', titleAlign: 'center' },
        ],
      ],
      masterSearchItems: {
        header: [
          'CUST_ID',
          'MSG_SNDR',
          'MSG_RCVR',
          'MSG_ID',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'PAGE_NUMBER',
          'PAGE_SIZE',
        ],
        data: [
          {
            CUST_ID: '',
            MSG_SNDR: '',
            MSG_RCVR: '',
            MSG_ID: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '',
            PAGE_NUMBER: '1',
            PAGE_SIZE: '25',
          },
        ],
        init: {
          DAT_TYPE: '',
          FR_DAT: beforeOneMonth(),
          TO_DAT: getAppliedTimeZone(),
          FR_DAT_PREV: beforeOneMonth(),
          TO_DAT_PREV: getAppliedTimeZone(),
          FR_DAT_ERROR: [],
          TO_DAT_ERROR: [],
        },
      },
      openLayoutViewItems: {
        header: [
          'CUST_ID',
          'OWNR_CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'MSG_CNT',
          'MAP_NAME',
          'FFL_FILE_NAME',
          'MAP_CONV_TP',
        ],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_STD: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            MSG_CNT: '',
            FFL_FILE_NAME: '',
            MAP_NAME: '',
            MAP_CONV_TP: '',
          },
        ],
      },
      saveItemsHeader: {
        header: [
          'SYSSTATUS',
          'SRM_PRCS_NO',
          'LAY_PRCS_NO',
          'MAP_PRCS_NO',
          'CUST_ID',
          'OWNR_CUST_ID',
          'SRM_PRCS_STS',
          'SRM_SNDR',
          'SRM_RCVR',
          'SRM_MSG_ID',
          'SRM_COMM_TP',
        ],
        data: [
          {
            SYSSTATUS: '',
            SRM_PRCS_NO: '',
            LAY_PRCS_NO: '',
            MAP_PRCS_NO: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            SRM_PRCS_STS: '',
            SRM_SNDR: '',
            SRM_RCVR: '',
            SRM_MSG_ID: '',
            SRM_COMM_TP: '',
          },
        ],
      },
      deleteDataParams: {
        header: ['PRCS_STS', 'LAY_PRCS_NO', 'SRM_PRCS_NO'],
        data: [],
      },
      downloadReferenceHeader: {
        header: ['SRM_PRCS_NO'],
        data: [{ SRM_PRCS_NO: '' }],
      },
      searchBy: 'all',
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Sender', value: 'SRM_SNDR' },
        { text: 'Receiver', value: 'SRM_RCVR' },
        { text: 'Message', value: 'SRM_MSG_ID' },
        { text: 'Create Date', value: 'SRM_CRE_DT' },
        { text: 'Update Date', value: 'SRM_UPD_DT' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      senders: [],
      dateTypes: [],
      dialogId: 1,
      selected: null,
      selectMasterRows: [],
      layoutViewArr: [],
      uploadFileViewArr: [],
      statusStatArr: [],
      // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
      communicationArr: [],
      srmStatusArr: [],
      srmStatusSearchArr: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      page: 1,
      pageCount: 0,
      pageEnter: 1, // 2021.11.25 203728 SPKA-274 modify paging
      isFilter: false,
      pageList: [{ value: 1, text: 'Page 1' }],
      totalCnt: 0,
      totalStt: 0,
      itemsPerPage: 100,
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      isClickLayout: true,
      isLoading: true,
      // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
      rowKey: '',
      rowCurrentClick: -1,
      listFrozen: ['SRM_SNDR', 'SRM_RCVR', 'SRM_MSG_ID', 'SRM_PRCS_STS', 'layout'],
    };
  },
  watch: {
    statusList: function(data) {
      this.statusStatArr = [];
      for (let i = 0; i < data.length; i++) {
        let item = {};
        let status = data[i];
        let code = status.SRM_PRCS_STS;
        let name = status.SRM_PRCS_STS_NM;
        if (code == 'DELE') {
          continue;
        }
        if (code == 'SL') {
          name = 'Initialized';
        }
        item.value = code;
        item.name = name;
        item.count = status.CNT;
        item.color = '';
        item.class = `srm-${name.replace(' ', '').toLowerCase()}-status`;
        if (code == 'SL') {
          item.class = 'srm-init-status';
        }
        this.statusStatArr.push(item);
      }
    },
    // 2021.11.25 203728 SPKA-274 modify paging
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);
        this.saveItems(data);
      };
      reader.readAsBinaryString(file);
    },
    onFileChanged(e) {
      const files = e.target.files || [];
      let validExts = ['.xlsx', '.xls'];
      if (files && files[0]) {
        let fileExt = files[0].name.substring(files[0].name.lastIndexOf('.'));
        if (validExts.indexOf(fileExt) < 0) {
          this.$refs.validateUpload.dialog = true;
        } else {
          this.file = files[0];
          this.readFile(files[0]);
        }
      }
    },
    sortChange(data) {
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        let searchBy = this.searchBy;
        Store.commit('srmlist/sortMapList', { col, sort, searchBy });
        this.setVisibilitySortIcon(col, sort);
        this.$refs.srm_list_table.clearCurrentRow();
        this.columns.map((e) => {
          $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        });
        let index = this.mainGrid.findIndex((e) => e.ROWID === this.rowKey);
        if (index > -1) {
          this.rowCurrentClick = index;
          this.columns.map((e) => {
            $('#' + e.field + index).addClass('custom-row-click-v-table');
          });
        } else {
          this.columns.map((e) => {
            $('#' + e.field + index).removeClass('custom-row-click-v-table');
          });
        }
      }
    },
    setVisibilitySortIcon(colName, sort) {
      let classVisible = `.repo-list-table .v-table-header .${colName} .v-table-sort-icon`;
      $(classVisible).css('visibility', 'visible');
      if (sort === 'reset') {
        $(classVisible).removeAttr('style');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString =
        side === 'from' ? this.masterSearchItems.init.FR_DAT : this.masterSearchItems.init.TO_DAT;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from'
          ? (this.masterSearchItems.init.FR_DAT = dateString)
          : (this.masterSearchItems.init.TO_DAT = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT;
        }
      }
    },
    changePage(value) {
      this.page = value;
      this.queryList(this.page);
    },
    // 2021.11.25 203728 SPKA-274 process change page by input textbox
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.queryList(this.page);
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData) {
      this.columns.map((e) => {
        $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e.field + rowIndex).addClass('custom-row-click-v-table');
      });
      this.listFrozen.map((e) => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
      this.rowCurrentClick = rowIndex;
      this.rowKey = rowData.ROWID;
    },
    rowEnter(rowIndex) {
      this.listFrozen.map((e) => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
    },
    rowLeave(rowIndex) {
      if (this.rowCurrentClick !== rowIndex) {
        this.listFrozen.map((e) => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        });
      }
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    changeDtTp() {
      if (
        this.masterSearchItems.init.DAT_TYPE == undefined ||
        this.masterSearchItems.init.DAT_TYPE == null ||
        this.masterSearchItems.init.DAT_TYPE == ''
      ) {
        this.masterSearchItems.init.FR_DAT = '';
        this.masterSearchItems.init.TO_DAT = '';
      } else {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT || beforeOneMonth();
        this.masterSearchItems.init.TO_DAT =
          this.masterSearchItems.init.TO_DAT || getAppliedTimeZone();
      }
    },
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    getStatus() {
      this.codeSearchItems.data[0].GRP_CODE = 'A05';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        // console.log("--------- Finished to process Status List ----------");
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.srmStatusSearchArr.push(codeObj);
          this.srmStatusArr.push(codeObj);
        }
      });
    },
    getDateType() {
      this.codeSearchItems.data[0].GRP_CODE = 'A06';
      Store.dispatch('common/getCode', this.codeSearchItems)
        .then(() => {
          // console.log("--------- Finished to process Date Type ----------");
          this.dateTypes.push({ value: '', text: 'Search by' });
          for (let i = 0; i < this.codeList.length; i++) {
            let codeObj = {};
            codeObj.text = this.codeList[i].CM_CODE_NAME;
            codeObj.value = this.codeList[i].CM_CODE_ID + 'T';
            this.dateTypes.push(codeObj);
          }
          this.queryAll();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getCommunication() {
      this.codeSearchItems.data[0].GRP_CODE = 'A07';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        // console.log("--------- Finished to process Communication ----------");
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.communicationArr.push(codeObj);
        }
      });
    },
    queryList(pageChange) {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      //[2020-04-15] apply by CLV: Apply srmlist/queryList api
      // 203728 SPKA-49 issue 5 apply date conndition
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        // console.log("--------- getSummaryList ----------");
        this.totalCnt = 0;
        this.totalStt = 0;
        // console.log("before fromdate(" + this.masterSearchItems.init.FR_DAT + ")");
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.FR_DAT,
        );
        // console.log("after fromdate(" + this.masterSearchItems.data[0].FR_DAT + ")");
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.TO_DAT,
        );
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        this.masterSearchItems.data[0].PAGE_NUMBER = this.page;
        this.masterSearchItems.data[0].PAGE_SIZE = this.itemsPerPage;
        Store.dispatch('srmlist/queryList', this.masterSearchItems)
          .then(() => {
            /*
            203665 2020/12/28  Common issue 33 update pagination
          */
            this.statusList.forEach((item) => {
              this.totalStt = this.totalStt + parseInt(item.CNT);
              if (this.masterSearchItems.data[0].PRCS_STS === '') {
                this.totalCnt = this.totalCnt + parseInt(item.CNT);
              } else if (this.masterSearchItems.data[0].PRCS_STS === item.SRM_PRCS_STS) {
                this.totalCnt = this.totalCnt + parseInt(item.CNT);
              }
            });
            if (this.totalCnt % this.itemsPerPage == 0) {
              this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage);
            } else {
              this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
            }
            if (this.mainGrid.length == 0 && this.page > 1) {
              this.pageEnter = this.pageEnter - 1;
              this.changePageByTextbox(0);
            }
            if (pageChange == 'pageChange' && this.pageCount < this.page) {
              this.page = 1;
            }
            this.createPageList(this.pageCount);
            this.search = '';
            this.searchBy = 'all';
            this.onFilterAnalysis();
            this.selectMasterRows = [];
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.$refs.SearchCondition.dialog = true;
        this.isLoading = false;
      }
    },
    cellMerge(rowIndex, rowData, field) {
      if (
        field == 'custome' ||
        field == 'layout' ||
        field == 'MAP_NAME' ||
        field == 'FFL_FILE_NAME' ||
        field == 'MPD_FILE_NAME'
      ) {
        let filters = this.arrFilter.filter((item) => {
          return item.index == rowIndex;
        });
        if (filters.length == 1) {
          let filter = filters[0];
          return {
            colSpan: 1,
            rowSpan: filter.count,
            content: '',
            componentName: '',
          };
        }
      }
    },
    openMapperVersion(itemRow) {
      let type = 'mapperVersion';
      let item = {
        ROWID: 0,
        action: 'map',
        item: itemRow,
      };
      this.mapperVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('mapperVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openScannerVersion(itemRow) {
      let type = 'scannerVersion';
      let item = {
        ROWID: 0,
        action: 'map',
        item: itemRow,
      };
      this.mapperVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('scannerVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openScannerListCheckIn() {
      let type = 'scannerCheckIn';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('scannerCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperListCheckIn() {
      let type = 'mapperCheckIn';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('mapperCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
        loadFrom: 'map',
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openCodeTableDialog(codeCtg) {
      let type = 'selectCodeList';
      let item = {
        ROWID: 0,
        codeCtg: this.codeCtg,
      };
      let indexArrDialog = this.findDialog('selectCodeList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    selectCodeItem(item) {
      let listOb = Object.keys(this.$refs);
      if (listOb.includes('mapperCheckIn') && this.$refs.mapperCheckIn.length > 0) {
        this.$refs.mapperCheckIn[0].updateSelectCodeTitle(item);
      }
    },
    openLayoutView(item) {
      let index = this.layoutViewArr.findIndex((e) => e.ROWID === item.ROWID);
      if (index > -1) return window.layoutFocus[item.ROWID]();

      this.openLayoutViewItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
      this.openLayoutViewItems.data[0].MSG_STD = item.LAY_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID = item.LAY_MSG_ID;
      this.openLayoutViewItems.data[0].MAP_NAME = item.MAP_NAME;
      this.openLayoutViewItems.data[0].MAP_CONV_TP = item.MAP_CONV_TP;
      this.openLayoutViewItems.data[0].FFL_FILE_NAME = item.FFL_FILE_NAME;
      this.openLayoutViewItems.data[0].FFL_FRMT_TP = item.FFL_FRMT_TP;
      this.openLayoutViewItems.data[0].MSG_VER = item.LAY_MSG_VER;
      this.openLayoutViewItems.data[0].STR_SNDR = item.SRM_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR = item.SRM_RCVR;
      this.openLayoutViewItems.data[0].MSG_CNT = item.ATF_FILE_CNT;
      this.openLayoutViewItems.data[0].DAT_TYPE = this.masterSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].PRCS_STS = item.SRM_PRCS_STS;
      this.openLayoutViewItems.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO;
      this.openLayoutViewItems.data[0].SRM_PRCS_NO = item.SRM_PRCS_NO;
      this.openLayoutViewItems.data[0].ALIAS = '';
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;

      this.params = this.openLayoutViewItems.data[0];

      // 203737 05/14/2021 Issue 16 New windown popup doesn't open
      if (!this.isClickLayout) {
        return;
      }
      this.isClickLayout = false;
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));

      var w = window.open(
        `/edimanager/EdiAnalyzedView_SRM/${item.ROWID}`,
        '_blank',
        'width=1550,height=800,left=100,top=30',
      );
      if (this.$vuetify.theme.isDark == true) {
        w.theme = this.$vuetify.theme.isDark;
      }
      w.mode = 'MergeView';
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      w.addEventListener('load', () => {
        this.layoutViewArr.push(item);
        this.isClickLayout = true;
        console.log(this.layoutViewArr);
      });

      w.addEventListener(
        'message',
        (data) => {
          let message = data.data.message;
          console.log(message);
          if (message) {
            let index = this.findIndexItem(item, this.layoutViewArr, 'ROWID');
            this.layoutViewArr.splice(index, 1);
            Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));

            if (message === 'btn-close') {
              w.close();
            }
          }
        },
        false,
      );
      w.focusPopup = () => {
        w.focus();
      };
      if (
        typeof window.layoutOpenWindow == 'undefined' ||
        typeof window.layoutFocus == 'undefined'
      ) {
        window.layoutOpenWindow = { [item.ROWID.toString()]: w.closePopup };
        window.layoutFocus = { [item.ROWID.toString()]: w.focusPopup };
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
    },
    saveItems(data) {
      if (data.length > 0) {
        this.saveItemsHeader['data'] = [];
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          let status = this.srmStatusArr.find((e) => e.text == item.Status);
          let comTp = this.communicationArr.find((e) => e.text == item.Communication);

          this.saveItemsHeader.data.push({
            SYSSTATUS: 'I',
            SRM_PRCS_NO: '',
            LAY_PRCS_NO: '',
            CUST_ID: $cookies.get('comp-id'),
            OWNR_CUST_ID: $cookies.get('ownr-id'),
            SRM_PRCS_STS: status.value,
            SRM_SNDR: item.Sender,
            SRM_RCVR: item.Receiver,
            SRM_MSG_ID: item.Message,
            SRM_COMM_TP: comTp?.value || '',
          });
        }
      } else {
        this.saveItemsHeader['data'] = [];
        for (let i = 0; i < this.mainGrid.length; i++) {
          let item = this.mainGrid[i];

          if (typeof item.SYSSTATUS == 'undefined' || item.SYSSTATUS == '') {
            continue;
          }
          if (
            item.SRM_SNDR.trim() == '' ||
            item.SRM_RCVR.trim() == '' ||
            item.SRM_MSG_ID.trim() == ''
          ) {
            this.$refs.addNewRowEmptyDialog.dialog = true;
            return;
          }
          if (this.isDuplicateSRMItem(item)) {
            this.$refs.addNewRowDuplicateDialog.dialog = true;
            return;
          }
          this.saveItemsHeader.data.push({
            SYSSTATUS: item.SYSSTATUS,
            SRM_PRCS_NO: item.SRM_PRCS_NO,
            LAY_PRCS_NO: item.LAY_PRCS_NO,
            MAP_PRCS_NO: item.MAP_PRCS_NO,
            CUST_ID: $cookies.get('comp-id'),
            OWNR_CUST_ID: $cookies.get('ownr-id'),
            SRM_PRCS_STS: item.SRM_PRCS_STS,
            SRM_SNDR: item.SRM_SNDR,
            SRM_RCVR: item.SRM_RCVR,
            SRM_MSG_ID: item.SRM_MSG_ID,
            SRM_COMM_TP: item.SRM_COMM_TP,
          });
        }
      }

      Store.dispatch('srmlist/saveSRMList', this.saveItemsHeader).then(() => {
        $('.srm-list-table .v-scrollbar-wrap').scrollTop(0);
        $('#btn-open-file')[0].value = '';
        this.queryList();
      });
    },
    /*
      203665 2020/12/28  Common issue 33 update pagination
    */
    handlePageChange(value) {
      this.page = value;
      this.queryList('pageChange');
    },

    handlePageSizeChange(size) {
      this.itemsPerPage = size;
      this.page = 1;
      this.queryList();
    },
    createPageList(pageCount) {
      this.pageList = [];
      for (let i = 1; i < pageCount + 1; i++) {
        let obj = {};
        obj.text = 'Page ' + i;
        obj.value = i;
        this.pageList.push(obj);
      }
    },

    generateExcelFile() {
      let self = this;
      const excel = require('node-excel-export');

      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94',
            },
          },
          font: {
            color: {
              rgb: 'FFFFFFFF',
            },
            sz: 14,
          },
        },
      };

      //Here you specify the export structure
      const specification = {
        SRM_SNDR: {
          // <- the key should match the actual data key
          displayName: 'Sender', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_RCVR: {
          // <- the key should match the actual data key
          displayName: 'Receiver', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_MSG_ID: {
          // <- the key should match the actual data key
          displayName: 'Message', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_PRCS_STS: {
          // <- the key should match the actual data key
          displayName: 'Status', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) {
            // <- Renderer function, you can access also any row.property
            let item = self.srmStatusArr.find((item) => {
              return item.value == value;
            });
            return item ? item.text : '';
          },
          width: 120, // <- width in pixels
        },
        MAP_NAME: {
          // <- the key should match the actual data key
          displayName: 'Map', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        FFL_FILE_NAME: {
          // <- the key should match the actual data key
          displayName: 'FlatFile Layout', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        MPD_FILE_NAME: {
          // <- the key should match the actual data key
          displayName: 'Mapping Definition', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        ATF_FILE_NAME: {
          // <- the key should match the actual data key
          displayName: 'Reference Files', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_COMM_TP: {
          // <- the key should match the actual data key
          displayName: 'Communication', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) {
            // <- Renderer function, you can access also any row.property
            let item = self.communicationArr.find((item) => {
              return item.value == value;
            });
            return item ? item.text : '';
          },
          width: 120, // <- width in pixels
        },
        SRM_CRE_DT: {
          // <- the key should match the actual data key
          displayName: 'Create Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_UPD_DT: {
          // <- the key should match the actual data key
          displayName: 'Update Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_CRE_USR: {
          // <- the key should match the actual data key
          displayName: 'Create User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
        SRM_UPD_USR: {
          // <- the key should match the actual data key
          displayName: 'Update User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120, // <- width in pixels
        },
      };

      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport([
        // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
        {
          name: 'Report', // <- Specify sheet name (optional)
          heading: [], // <- Raw heading array (optional)
          merges: [], // <- Merge cell ranges
          specification: specification, // <- Report specification
          data: this.mainGrid, // <-- Report data
        },
      ]);

      var data = new Blob([report.buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = window.URL.createObjectURL(data);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'SRMList.xlsx';
      document.body.appendChild(a);
      a.click();
    },

    isDuplicateSRMItem(item) {
      for (let i = 0; i < this.mainGrid.length; i++) {
        let srmitem = this.mainGrid[i];
        if (item.ROWID == srmitem.ROWID) {
          continue;
        }
        if (
          item.SRM_SNDR == srmitem.SRM_SNDR &&
          item.SRM_RCVR == srmitem.SRM_RCVR &&
          item.SRM_MSG_ID == srmitem.SRM_MSG_ID
        ) {
          return true;
        }
      }
      return false;
    },

    onFilterAnalysis(str) {
      // 2021.9.9 203728 SPKA-199 Clear select row
      this.$refs.srm_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
      this.isFilter = true;
      if (this.searchBy == 'all' && this.search == '') {
        this.isFilter = false;
      }
      let datarows = this.mainGridSource;
      let filterBy = { filter: this.searchBy, str: this.search };
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      Store.commit('srmlist/mainGridFilter', listResult);
    },

    srmStatusClass(item) {
      if (typeof item.SRM_PRCS_STS == 'string') {
        return `srm-${item.SRM_PRCS_STS.toLowerCase()}-select-box-status`;
      }
    },

    selectItemChange(selection, rowData) {
      this.selectMasterRows = selection;
    },
    selectAllChange(selection) {
      this.selectMasterRows = selection;
      console.log(this.selectMasterRows);
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    openMapListDialog(selectItem) {
      let type = 'mapList';
      let item = {
        ROWID: 0,
        item: selectItem,
      };
      let indexArrDialog = this.findDialog('mapList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddReferenceFileDialog(rowItem) {
      let type = 'addReferenceFile';
      let item = {
        ROWID: 0,
        item: rowItem,
      };
      let indexArrDialog = this.findDialog('addReferenceFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    downloadAttachFile(srmitem) {
      this.downloadReferenceHeader.data[0].SRM_PRCS_NO = srmitem.SRM_PRCS_NO;
      Store.dispatch('srmlist/downloadAllReferenceFiles', this.downloadReferenceHeader).then(() => {
        console.log('--------- Finished to process ----------');
      });
    },
    openReferenceList(selectedItem) {
      let type = 'refenrenceFilesList';
      let item = {
        ROWID: 0,
        item: selectedItem,
      };
      let indexArrDialog = this.findDialog('refenrenceFilesList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    loadMapList(item) {
      this.mapFile = item.MAP_NAME;
    },

    addRowSRMList() {
      let newRow = {
        ROWID: this.getMaxRowID(),
        SRM_SNDR: '',
        SRM_RCVR: '',
        SRM_MSG_ID: '',
        SRM_PRCS_STS: 'SL',
        layout: '',
        MAP_NAME: '',
        FFL_FILE_NAME: '',
        MPD_FILE_NAME: '',
        ATF_FILE_NAME: '',
        SRM_COMM_TP: '',
        SRM_CRE_DT: '',
        SRM_UPD_DT: '',
        SRM_CRE_USR: '',
        SRM_UPD_USR: '',
        SYSSTATUS: 'I',
        SRM_PRCS_NO: '',
      };
      this.mainGrid.push(newRow);
      setTimeout(() => {
        $('.srm-list-table .v-scrollbar-wrap').scrollTop(this.mainGrid.length * 40);
      }, 300);
    },

    deleteSRMRowItem(item) {
      let index = this.findIndexItem(item, this.mainGrid, 'ROWID');
      if (index != null) {
        this.mainGrid.splice(index, 1);
      }
    },
    setRowClassName(index, item) {
      if (item['hidden']) {
        return 'd-none';
      }
    },
    selectStatus(status, pageChange) {
      /*
      203665 2020/12/28  Common issue 33 update select status
      */
      if (typeof pageChange == 'undefined' || pageChange != 'pageChange') {
        this.page = 1;
        this.masterSearchItems.data[0].PAGE_NUMBER = 1;
        this.masterSearchItems.data[0].PAGE_SIZE = this.itemsPerPage;
      }
      this.totalCnt = 0;
      if (status == 'All') {
        this.masterSearchItems.data[0].PRCS_STS = '';
      } else {
        this.masterSearchItems.data[0].PRCS_STS = status.value;
      }
      Store.dispatch('srmlist/queryList', this.masterSearchItems).then(() => {
        // console.log("--------- Finished to process ----------");
        this.statusList.forEach((item) => {
          if (status == 'All') {
            this.totalCnt = this.totalCnt + parseInt(item.CNT);
          } else if (status.value === item.SRM_PRCS_STS) {
            this.totalCnt = this.totalCnt + parseInt(item.CNT);
          }
        });
        if (this.totalCnt % this.itemsPerPage == 0) {
          this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage);
        } else {
          this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
        }
        this.createPageList(this.pageCount);
        this.selectMasterRows = [];
      });
    },
    deleteData() {
      if (this.selectMasterRows.length > 0) {
        this.$refs.deleteDialog.dialog = true;
      }
    },
    onDelete() {
      let dataMerge = [];
      let dataDelete = [];
      if (this.selectMasterRows.length > 0) {
        // for(var i = 0; i < this.selectMasterRows.length; i++){
        //   console.warn('this.selectMasterRows[i]',this.selectMasterRows[i])
        //   this.deleteDataParams.data[i] = {
        //     PRCS_STS: 'SRML',
        //     LAY_PRCS_NO: `${this.selectMasterRows[i].LAY_PRCS_NO}`,
        //     SRM_PRCS_NO: `${this.selectMasterRows[i].SRM_PRCS_NO}`
        //   };
        // }
        for (var i = 0; i < this.selectMasterRows.length; i++) {
          let temp = this.mainGrid.filter(
            (e) =>
              this.selectMasterRows[i].LAY_PRCS_NO !== null &&
              e.LAY_PRCS_NO == this.selectMasterRows[i].LAY_PRCS_NO,
          );
          if (temp.length > 1) {
            for (var j = 0; j < temp.length; j++) {
              dataMerge.push({
                PRCS_STS: 'SRML',
                LAY_PRCS_NO: `${temp[j].LAY_PRCS_NO}`,
                SRM_PRCS_NO: `${temp[j].SRM_PRCS_NO}`,
              });
            }
          }
          dataDelete.push({
            PRCS_STS: 'SRML',
            LAY_PRCS_NO: `${this.selectMasterRows[i].LAY_PRCS_NO}`,
            SRM_PRCS_NO: `${this.selectMasterRows[i].SRM_PRCS_NO}`,
          });
        }
        let ids = new Set(dataMerge.map((e) => e.SRM_PRCS_NO));
        let merged = [...dataMerge, ...dataDelete.filter((e) => !ids.has(e.SRM_PRCS_NO))];
        this.deleteDataParams.data = [...merged];

        Store.dispatch('srmlist/deleteSRMListProcData', this.deleteDataParams).then(() => {
          this.$refs.deleteSuccesssDialog.dialog = true;
        });
      }
      this.selectMasterRows = [];
      // this.queryAll();
    },
    getMaxRowID() {
      let maxRowID = 1;
      for (let i = 0; i < this.mainGrid.length; i++) {
        if (maxRowID <= this.mainGrid[i].ROWID) {
          maxRowID = this.mainGrid[i].ROWID + 1;
        }
      }
      return maxRowID;
    },

    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    newDialogMapList(item, type) {
      return this.dialogs.push(this.generateDialogMapList(item, type));
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item: item.item };
      return { id, name, type, options };
    },
    reFreshList() {
      this.$refs.mapList[0].queryMapList();
    },
    generateDialogMapList(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    updatedMap(mapItems) {
      let { item, selectItem } = mapItems;
      selectItem.MAP_NAME = item.MAP_NAME;
      selectItem.FFL_FILE_NAME = item.FFL_FILE_NAME;
      selectItem.MPD_FILE_NAME = item.MPD_FILE_NAME;
      selectItem.MAP_PRCS_NO = item.MAP_PRCS_NO;
      selectItem.SYSSTATUS = selectItem.SRM_PRCS_NO ? 'U' : selectItem.SYSSTATUS;
    },
    updatedFile(fileItems) {
      let { item, selectItem } = fileItems;
      selectItem.ATF_FILE_CNT = item.length;
      selectItem.ATF_FILE_NAME = item[0].ATF_FILE_NAME;
      selectItem.SYSSTATUS = selectItem.SRM_PRCS_NO ? 'U' : selectItem.SYSSTATUS;
    },
    afterUpdateTable() {
      setTimeout(() => {
        let scrollbar = $('.v-scrollbar-wrap').first();
        let scrolltop = scrollbar.scrollTop();
        scrollbar.scrollTop(scrolltop - 1);
        scrollbar.scrollTop(scrolltop + 1);
        scrollbar.scrollTop(scrolltop);
      }, 3);
    },
    updatedReferenceFiles(referenceFilesItems) {
      let { item, selectItem } = referenceFilesItems;
      this.$refs.addReferenceFile[0].addreferenceFileRow(referenceFilesItems);
    },
    queryAll() {
      this.queryList();
      this.getStatus();
      this.getCommunication();
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
  },
  created() {
    this.changeDtTp();
    this.tooltipWidth = config.tooltipWidth;
    this.dateTimeFormat = config.dateTimeFormat;
    this.getDateType();
    this.isCreated = true;
    Store.commit('srmlist/RESET_FILTER_AND_SORT');
  },
  // 2021.11.25 203728 SPKA-274 modify paging
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-bg'];
    let arrClassPlus = [];

    if (this.isCreated) {
      // Minus height border 2px
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 2;
      if (self.$refs.srm_list_table != undefined) {
        self.$refs.srm_list_table.initView();
        self.$refs.srm_list_table.scrollControl();
        self.$refs.srm_list_table.resize();
      }
      self.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 2;
      if (self.$refs.srm_list_table != undefined) {
        self.$refs.srm_list_table.initView();
        self.$refs.srm_list_table.scrollControl();
        self.$refs.srm_list_table.resize();
      }
    });
  },

  mounted() {},
};
</script>

<style>
.srm-total-status-section {
  display: inline-block;
  margin-right: 20px;
}
.status-stat-section {
  font-size: 11px;
  font-weight: bold;
}
.srm-added-status {
  background: #ffffff;
  border: 0.5px solid #7d838d;
}
.srm-status-stat {
  display: inline-block;
  cursor: pointer;
}
.srm-status-name {
  display: inline-block;
  text-align: center;
  width: 90px;
  border: 0.5px solid #7d838d;
  font-size: 11px;
  line-height: 21px;
  font-weight: 600;
  color: #606268;
  margin-right: 10px;
}
.srm-status-count {
  font-size: 16px;
  line-height: 21px;
  color: #0082ba;
  margin-right: 15px;
}
.srm-created-status {
  background: #ffffff;
}
.srm-init-status {
  background: #e0f6ff;
}
.srm-developing-status {
  background: #fffce0;
}
.srm-testing-status {
  background: #fffce0;
}
.srm-completed-status {
  background: #e8ffe0;
}
.srm-onlive-status {
  background: #ffe4e0;
}
.srm-total-status-text {
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  margin-right: 4px;
  align-items: center;
  color: #18236d;
}
.srm-total-status {
  font-size: 16px;
  line-height: 21px;
  color: #0082ba;
  padding-left: 2px;
  padding-right: 2px;
}
.add-refe-file-col .ref-file-icon {
  position: absolute;
  right: 0;
  line-height: 27px;
}
.add-refe-file-col {
  position: relative;
  width: 100%;
  height: 100%;
}
.action-section.search-bar button.primary {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.action-row.btn-form-control .btn-height-custom {
  margin-bottom: 0px !important;
}

.srm-list-container
  .v-text-field.data-table-filter-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  margin-left: 0px !important;
}
.srm-total-status-section span,
.srm-status-stat span {
  vertical-align: bottom;
}
/*.status-stat-section {}*/
.flatfile-layout-list {
  width: 888px !important;
  height: 410px !important;
}
.srm-list-table {
  min-height: 0px !important;
}
.srm-list-table .mr-2.ref-file-icon {
  margin: 4px !important;
}
.theme--dark
  .data-table-select-box.search-selectbox
  .v-input__control
  .v-input__slot
  .v-select__selections
  .v-select__selection {
  color: #bbbbbb !important;
}
.theme--dark
  .data-table-select-box.search-selectbox
  .v-input__control
  .v-input__slot
  .v-input__append-inner
  i {
  color: white !important;
}
.theme--dark .srm-total-status-text {
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  align-items: center;
  color: #bbbbbb;
}
.hiden-col {
  display: none;
}
.table-title .v-table-sort-icon {
  padding-left: 8px;
  width: 24px;
}
.table-title .v-table-sort-icon i:first-child {
  top: 2px;
}
.MAP_NAME .table-title {
  width: 200px;
}
</style>
